import CRUDService from "./CRUDService";
class UserAdminViewService extends CRUDService {
    constructor() {
        super("user-admin-view");
    }
}

export default new UserAdminViewService();
